(function () {
  "use strict";

  function init() {
    var root = document.querySelector(".ccw22[data-cc-shopify-native]");
    var form = root && root.querySelector("#CCWholesaleForm");
    if (!root || !form || root.dataset.ccw22Ready === "true") return;
    root.dataset.ccw22Ready = "true";

    var result = form.querySelector("[data-cc-form-result]");
    if (result) result.focus();

  var status = root.querySelector("[data-ccw22-path-status]");
  var type = form.querySelector("#ccw-type");
  var manualInterestChoices = new WeakMap();
  var paths = {
    bar: { type: "Bar / Restaurant", checks: ["Interest - Wholesale pricing", "Interest - Menu implementation"] },
    hotel: { type: "Hotel / Resort", checks: ["Interest - Wholesale pricing", "Interest - Hotel program"] },
    event: { type: "Event Company / Mobile Bar", checks: ["Interest - Event batching"] },
    retail: { type: "Retailer", checks: ["Interest - Retail distribution"] }
  };

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function inputFor(label) {
    return form.querySelector('input[name="contact[' + label + ']"]');
  }

  function setChecked(checkbox, checked) {
    checkbox.checked = checked;
    var label = checkbox.closest(".for-checkable");
    if (label) label.classList.toggle("ccw22-checkable-selected", checked);
  }

  form.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
    if (checkbox.checked) manualInterestChoices.set(checkbox, true);
    checkbox.addEventListener("change", function () {
      manualInterestChoices.set(checkbox, checkbox.checked);
      setChecked(checkbox, checkbox.checked);
    });
  });

    function chooseWholesalePath(key, trigger, event) {
      var path = paths[key];
      if (!path) return true;
      if (event) event.preventDefault();

      root.querySelectorAll(".ccw22-path-selector-grid [data-wholesale-path]").forEach(function (candidate) {
        candidate.setAttribute("aria-pressed", candidate === trigger ? "true" : "false");
        candidate.classList.toggle("ccw22-path-active", candidate === trigger);
      });
      if (type) type.value = path.type;
      form.querySelectorAll('input[type="checkbox"]').forEach(function (checkbox) {
        setChecked(checkbox, manualInterestChoices.has(checkbox) ? manualInterestChoices.get(checkbox) : false);
      });
      path.checks.forEach(function (label) {
        var input = inputFor(label);
        if (input && !manualInterestChoices.has(input)) setChecked(input, true);
      });
      if (status) status.textContent = (trigger ? trigger.textContent.trim() : "Wholesale path") + " selected. Matching form fields have been prefilled.";
      form.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "start" });
      window.setTimeout(function () { if (type) type.focus(); }, prefersReducedMotion() ? 0 : 450);
      return false;
    }

    window.ccw22ChooseWholesalePath = chooseWholesalePath;
    root.querySelectorAll("[data-wholesale-path]").forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        chooseWholesalePath(trigger.getAttribute("data-wholesale-path"), trigger, event);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
